import { inject } from 'vue'

export const analyticsKey = Symbol('analytics')

export function useAnalytics() {
    const analytics = inject(analyticsKey, null)

    if (!analytics) throw new Error('Analytics service is not registered.')

    return analytics
}
